import { WordingMultiAstrologyMeditationLove } from '@/types';

export const MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_DE: WordingMultiAstrologyMeditationLove = {
  components_header_media_content: 'Astrologie',
  components_header_media_multi_content_2: 'Meditation',
  components_header_media_multi_content_3: 'Liebe',
  components_header_text1: 'Leitfäden',
  components_header_text2: 'Blog',
  hero_text: 'Finde Klarheit, Ausgeglichenheit und Verbundenheit.',
  hero_button_text: 'Beginne deine Reise',
  components_ressources_subheader_text: 'Tipps und Inspiration',
  components_ressources_span_text: 'Es vereint persönliche astrologische Erkenntnisse, beruhigende Meditationspraktiken und einfühlsame Liebesratgeber, um Selbstfindung, emotionales Gleichgewicht und tiefere Verbundenheit zu unterstützen.',
  components_ressources_card_1_title: 'Meditationstipps',
  components_ressources_card_1_text: 'Kurzanleitung für mehr Ruhe, Atmung und Konzentration.',
  components_ressources_card_2_title: 'Liebesführung',
  components_ressources_card_2_text: 'Einfache Tipps für stärkere Beziehungen und mehr emotionales Gleichgewicht.',
  components_ressources_link: 'Mehr erfahren',
  components_notes_and_google_title_1: 'Klarheit finden',
  components_notes_and_google_title_2: 'Innere Ruhe',
  components_notes_and_google_title_3: 'Herzverbindung',
  media_content_section_multi_1_subheader_text: 'Unser Podcast',
  media_content_section_multi_2_subheader_text: 'Unsere Meditationen',
  media_content_section_multi_3_subheader_text: 'Klartext über kosmische Romantik',
  page_media_content_menu_antistress: 'Antistress',
  page_media_content_menu_mindfulness: 'Achtsamkeit',
  page_media_content_menu_energyboost: 'Energieschub',
  page_media_content_menu_mantra: 'Mantra',
  page_media_content_menu_foundations: 'Fundamente',
  page_media_content_menu_spirituality: 'Spiritualität',
  page_media_content_menu_tarot: 'Tarot',
  page_media_content_menu_psychology: 'Psychologie',
  page_media_content_menu_trends: 'Trends',
  page_media_content_menu_compatibility: 'Kompatibilität',
  page_media_content_menu_love: 'Liebe',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Artikel & Einblicke',
  text2_section_button_more: 'Mehr laden',
  components_text1_section_title: 'REISEFÜHRER',
  components_text1_subheader_text: 'Kosmisches Wissen für die tägliche Ausrichtung',
  components_text1_span_text: 'Richte dich nach den Rhythmen des Universums aus: Entdecke eine sorgfältig zusammengestellte Sammlung tiefgründiger astrologischer und meditativer Anleitungen, die dir helfen, innere Klarheit zu erwecken, dein Selbstbewusstsein zu vertiefen und deine Reise des seelischen, himmlischen Wachstums zu unterstützen.',
  components_text1_card_1_title: 'Offen für die Stille',
  components_text1_card_1_text: 'Beginnen Sie Ihre Reise mit grundlegenden Anleitungen zu Meditation und Astrologie – ideal für Suchende, die sich nach innerer Stille, kosmischen Mustern und persönlicher Erkenntnis sehnen.',
  components_text1_card_3_title: 'Verbindung zwischen Geist und Körper',
  components_text1_card_3_text: 'Entdecken Sie die tieferen Schichten Ihrer inneren Welt. Diese Anleitungen dringen über die Oberfläche hinaus und enthüllen Bedeutung, Emotionen und achtsame Verhaltensmuster, die Ihre Erfahrungen prägen.',
  components_text1_card_2_title: 'Reflektieren & Integrieren',
  components_text1_card_2_text: 'Von emotionalen Blockaden bis hin zu planetarischen Zyklen – diese Ratgeber bieten Werkzeuge zur Reflexion, Heilung und Transformation durch achtsame Rituale und astrologische Weisheit.',
  components_text1_link: 'Alle Anleitungen anzeigen',
  components_footer_text: 'Finde Klarheit, bringe deinen Geist ins Gleichgewicht und verbinde dich mit Sinn – dein Ort für Astrologie, Meditation und Liebe.',
};